var collectionBanner = document.querySelector(
  ".shopify-section--collection-banner",
);
var collectionSlideshow = document.querySelector(".shopify-section--slideshow");
var collectionImageWithTextOverlay = document.querySelector(
  ".shopify-section--image-with-text-overlay",
);
if (collectionBanner || collectionSlideshow || collectionImageWithTextOverlay) {
  document.querySelector("body").classList.add("caremare-logo");

  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      document.querySelector("body").classList.remove("caremare-logo");
    } else {
      document.querySelector("body").classList.add("caremare-logo");
    }
  });
}

if (!window.customElements.get("product-sticky-bar")) {
  const STICKY_BAR_SCROLL_THRESHOLD = 0.5;

  class ProductStickyBar extends HTMLElement {
    #observer = new IntersectionObserver(this.#onFooterVisibilityChange.bind(this));
    #footerElement;
    #footerVisible = false;
    #scrolledPastThreshold = false;
    #onScrollBound = this.#onScroll.bind(this);

    connectedCallback() {
      this.#footerElement = document.querySelector(".shopify-section--footer");
      if (this.#footerElement) {
        this.#observer.observe(this.#footerElement);
      }
      window.addEventListener("scroll", this.#onScrollBound, { passive: true });
      this.#onScroll();
    }

    disconnectedCallback() {
      this.#observer.disconnect();
      window.removeEventListener("scroll", this.#onScrollBound);
    }

    #onFooterVisibilityChange(entries) {
      const footerEntry = entries[0];
      this.#footerVisible = footerEntry.isIntersecting;
      this.#updateVisibility();
    }

    #onScroll() {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolledRatio = scrollableHeight > 0 ? window.scrollY / scrollableHeight : 1;
      this.#scrolledPastThreshold = scrolledRatio >= STICKY_BAR_SCROLL_THRESHOLD;
      this.#updateVisibility();
    }

    #updateVisibility() {
      this.classList.toggle("is-visible", this.#scrolledPastThreshold && !this.#footerVisible);
    }
  }

  window.customElements.define("product-sticky-bar", ProductStickyBar);
}